import { EULAHTML } from "./texts";
import PolicyPage from "./PolicyPage";

export default function Eula() {
  return (
    <PolicyPage
      html={EULAHTML}
      title="End User License Agreement — ThriveOn Calorie Tracker"
      description="The terms under which the ThriveOn calorie tracker app is licensed to you."
      path="/eula"
    />
  );
}
